import { apiUrl } from './api';

async function supportRequest(path, { method = 'GET', body, token, accessToken } = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (accessToken) {
    headers['x-support-chat-token'] = accessToken;
  }

  const response = await fetch(apiUrl(path), {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Request failed: ${response.status}`);
  }

  return payload;
}

export function createSupportChat(payload, options = {}) {
  return supportRequest('/support/chats', {
    method: 'POST',
    body: payload,
    ...options,
  });
}

export function fetchSupportChat(chatId, options = {}) {
  return supportRequest(`/support/chats/${chatId}`, options);
}

export function fetchSupportMessages(chatId, options = {}) {
  return supportRequest(`/support/chats/${chatId}/messages`, options);
}

export function sendSupportMessage(chatId, payload, options = {}) {
  return supportRequest(`/support/chats/${chatId}/messages`, {
    method: 'POST',
    body: payload,
    ...options,
  });
}

export async function uploadSupportAttachment(file, { chatId, token, accessToken } = {}) {
  if (!file) {
    throw new Error('No file selected for upload.');
  }

  if (!chatId) {
    throw new Error('Start a support chat before uploading files.');
  }

  const formData = new FormData();
  formData.append('file', file);

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (accessToken) {
    headers['x-support-chat-token'] = accessToken;
  }

  const response = await fetch(apiUrl(`/support/chats/${chatId}/uploads`), {
    method: 'POST',
    headers,
    body: formData,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Upload failed: ${response.status}`);
  }

  return payload;
}

